import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { FaPlus } from "react-icons/fa";
import { RxCross1 } from "react-icons/rx";
import { useMutation } from "react-query";
import { QuizAPI } from "../../Api/Quiz";
import { Toast } from "../../Hooks/useToast";
import { Button, Input } from "../CustomComponent";
import FullPageLoader from "../Loader/FullPageLoader";
import { useAppContext } from "../../Context/AppContext";
import _ from "lodash";

const InviteModal = ({ setIsOpen, modalData, isLoading }) => {
  const { isWebView } = useAppContext();
  const quiz = QuizAPI();

  const {
    reset,
    setValue,
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm({ mode: "onChange" });


  const email = watch('email')
  const [emailList, setEmailList] = useState([]);
  const [isSubmitted, setSubmitted] = useState(false)


  const inviteMutation = useMutation({
    mutationFn: async (data) => {
      const response = await quiz.inviteQuiz(data);
      return response.data;
    },
    onSuccess: () => {
      Toast("Invite Sent Successfully", "success", false);
      handleCancel();
      reset();
    },
    onError: (error) => {
      console.error("Failed to delete quiz:", error);
      Toast(error.message, "error", false);
      setSubmitted(false)
    },
  });


  useEffect(() => {
    window.inviteUsers = (link = '') => {
      inviteMutation.mutateAsync({ quiz_id: modalData?.id, email: emailList, link: link })
    }
  }, [emailList])


  const onSubmit = (data) => {
    if (isSubmitted) return;
    if (!emailList.length) {
      return Toast('Please add email to send invite', "error", false);
    }

    setSubmitted(true)
    if (!isWebView || !window?.FlutterChannel) {
      inviteMutation.mutateAsync({ quiz_id: modalData?.id, email: emailList });
    }
    else {
      window.FlutterChannel.postMessage('invite-' + modalData.code);
    }
  };

  function handleCancel(e) {
    e?.preventDefault();
    setIsOpen(false);
  };

  const handleAddEmail = () => {
    if (isSubmitted || !email) return;
    const emailRegex = /^[\w\.-]+@[\w\.-]+\.\w+$/;

    const splitEmail = email?.split(',')?.map(item => item?.trim()?.toLowerCase())?.filter(item => !!item);
    const newEmails = splitEmail?.filter(email => emailRegex.test(email) && !emailList?.includes(email));
    const filterEmail = Array.from(new Set(newEmails));

    if (filterEmail.length !== splitEmail.length) {
      Toast('Contain invalid or duplicated email(s)', 'error', false)
    }

    setValue('email', splitEmail?.filter(item => !filterEmail.includes(item))?.join(','))
    setEmailList(prev => ([...(new Set([...prev, ...filterEmail]))]));
  }

  const handleRemoveEmail = (index) => {
    if (isSubmitted) return;
    setEmailList(prev => {
      return prev.filter((item, ind) => ind !== index)
    })
  }

  return (
    <>
      <div className="invite-modal-content">
        <div className="tag-container">

          {
            emailList.map((item, index) => {
              return <div key={index} className="tag">
                {item}
                <span className={'cross-icon'}><RxCross1 size={8} onClick={() => handleRemoveEmail(index)} /></span>
              </div>
            })
          }
        </div>

        <Form onSubmit={handleSubmit(onSubmit)}>
          <Controller
            name="email"
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                label="Enter Email Address"
                placeholder="Add Here"
                errors={errors}
                rules={{
                  required: {
                    value: true,
                    message: "Please enter a valid email address"
                  },
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Please enter a valid email address"
                  }
                }}
                inputClasses="pe-4"
                sufixIcon={<span className="cursor-pointer" onClick={handleAddEmail}><FaPlus /></span>}
                bg={false}
              />
            )}
          />

          <div className="w-100">
            <Button
              classes="cancel-btn w-100 text-white"
              onClick={handleCancel}
              text="Cancel"
            />
            <Button
              classes="cancel-btn w-100 text-white mt-3"
              text={isSubmitted ? <Spinner /> : "Send Invite"}
              disabled={isSubmitted}
              type="submit"
            />
          </div>
        </Form>
      </div>
    </>
  );
};

export default InviteModal;
